<template>
<b-modal :active.sync="showCreateModal" has-modal-card>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title"><translate>createModal.header.{{ field }}</translate></p>
    </header>
    <section class="modal-card-body" style="overflow-x: hidden">
      <fob-entity-create-form
        @update:invalid="value => isInvalid = value"
        :showErrors="showErrors"
        name="fob-modal-create-form-modal"
        :schema="schema"
        v-model="created"
      ></fob-entity-create-form>
    </section>
    <footer class="modal-card-foot">
      <button class="button is-danger" type="button" @click="cancel"><translate>createModal.button.cancel</translate></button>
      <button class="button is-primary" @click="requestSubmit"><translate>createModal.button.create</translate></button>
    </footer>
  </div>
</b-modal>
</template>

<script>
import { ToastError } from '@/utils'

export default {
  name: 'fob-entity-create-modal',
  data () {
    return {
      isInvalid: true,
      showErrors: false
    }
  },
  props: [
    'schema',
    'value',
    'active',
    'field'
  ],
  computed: {
    created: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    showCreateModal: {
      get () {
        return this.active
      },
      set (value) {
        this.$emit('update:active', value)
      }
    }
  },
  methods: {
    requestSubmit () {
      if (this.isInvalid) {
        this.showErrors = true
        ToastError(this.$gettext(`toast.validation.failed`))
      } else {
        this.submitCreated()
      }
    },
    submitCreated () {
      this.showCreateModal = false
      this.$emit('submit', this.created)
    },
    cancel () {
      this.showCreateModal = false
      this.showErrors = false
      this.$emit('cancel')
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/form/EntityCreateModal.vue